'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotHistogram2dIcon = function PlotHistogram2dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M32 16h-5.313v-5.313h-5.375V5.312H10.687v5.375H-.001V16h5.313v5.313h5.375v5.375h10.625v-5.375H32z' })
    );
};

exports.default = PlotHistogram2dIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotHistogram2dIcon.js
// module id = 663
// module chunks = 0